export const CALENDLY_URL = 'https://calendly.com/steven-poly-ai/30min';
